"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchGroup = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
var Select_1 = require("./Select");
var StyledGroup = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  border-radius: ", "px;\n  background-color: ", ";\n\n  > * {\n    flex-grow: 1;\n  }\n\n  ", " {\n    border-radius: 0;\n    &:first-child {\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n    }\n    &:last-child {\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n      background-color: transparent;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  border-radius: ", "px;\n  background-color: ", ";\n\n  > * {\n    flex-grow: 1;\n  }\n\n  ", " {\n    border-radius: 0;\n    &:first-child {\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n    }\n    &:last-child {\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n      background-color: transparent;\n    }\n  }\n"])), accessors_1.borderRadius('md'), accessors_1.color('secondary', 'darker'), Select_1.StyledSelect, accessors_1.borderRadius('md'), accessors_1.borderRadius('md'), accessors_1.borderRadius('md'), accessors_1.borderRadius('md'));
var SwitchGroup = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return react_1.default.createElement(StyledGroup, __assign({}, props), children);
};
exports.SwitchGroup = SwitchGroup;
var templateObject_1;
